/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';
import { GetOrganization } from './organization.get';

export const PostOrganization = {
  id: 'organization.post',
  tag: 'Organization',
  summary: 'Create organization',
  description: 'Create an organization. Requires superuser rights.',
  method: 'post',
  flags: { isAuthorized: true, isSuperuser: true },
  route: () => `/organization`,
  request: {
    body: {
      content: {
        'application/json': {
          schema: z.strictObject({
            name: ZodTypes.KubernetesIdentifier,
            description: z.string().trim().min(1).optional().nullable(),
            companyName: z.string().trim().min(1),
            email: z.string().trim().email().optional(),
            vatNumber: z.string().trim().min(1).optional(),
            language: ZodTypes.Language,
            address: z.strictObject({
              line1: z.string().trim().min(1),
              line2: z.string().trim().min(1).optional(),
              line3: z.string().trim().min(1).optional(),
              postalCode: z.string().trim().min(1),
              city: z.string().trim().min(1),
              state: z.string().trim().min(1).optional(),
              countryCode: ZodTypes.Country,
            }),
          }),
        },
      },
    },
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: GetOrganization.response['200'].content['application/json'].schema,
        },
      },
    },
  },
} as const satisfies Endpoint;
